// extracted by mini-css-extract-plugin
module.exports = {"instagram":"socialMedia_instagram__3ietd","icon":"socialMedia_icon__3oeoX","facebook":"socialMedia_facebook__3UdzJ"};